// src/api/categories.js
import axios from './axios';

export const categoriesAPI = {
  // Get all categories
  getAll: async () => {
    try {
      const response = await axios.get('/categories');
      console.log('Categories fetched:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw error;
    }
  },

  // Get single category by ID
  getById: async (id) => {
    try {
      const response = await axios.get(`/categories/${id}`);
      console.log('Category fetched:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching category:', error);
      throw error;
    }
  },

  // Create new category (Admin only)
  create: async (categoryData) => {
    try {
      const response = await axios.post('/categories', categoryData);
      console.log('Category created:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error creating category:', error);
      throw error;
    }
  },

  // Update category (Admin only)
  update: async (id, categoryData) => {
    try {
      const response = await axios.put(`/categories/${id}`, categoryData);
      console.log('Category updated:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error updating category:', error);
      throw error;
    }
  },

  // Delete category (Admin only)
  delete: async (id) => {
    try {
      const response = await axios.delete(`/categories/${id}`);
      console.log('Category deleted:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error deleting category:', error);
      throw error;
    }
  },
};